import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

const PERIODS = ["daily", "weekly", "monthly", "yearly"];
const FIELDS = [["revenue", "Collected revenue", true], ["outstanding", "Outstanding", true],
  ["bills", "Bills raised"], ["new_patients", "New patients"], ["consultations", "Consultations"]];

export default function Reports() {
  const { fq } = useApp();
  const [period, setPeriod] = useState("monthly");
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = [`period=${period}`, fq].filter(Boolean).join("&");
    api.get(`/reports/summary?${params}`).then(({ data }) => setData(data)).catch(() => {});
  }, [period, fq]);

  return (
    <div className="space-y-5" data-testid="reports-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-primary">Analytics</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Reports</h1>
      </div>
      <Tabs value={period} onValueChange={setPeriod}>
        <TabsList>
          {PERIODS.map((p) => (
            <TabsTrigger key={p} value={p} data-testid={`report-period-${p}`} className="capitalize">{p}</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {data && FIELDS.map(([k, label, money]) => (
          <Card key={k} className="shadow-sm" data-testid={`report-${k}`}>
            <CardHeader className="pb-1"><CardTitle className="text-xs text-muted-foreground font-normal">{label}</CardTitle></CardHeader>
            <CardContent>
              <p className="font-heading text-2xl font-bold tabular-nums">
                {money ? `₹${Number(data[k]).toLocaleString("en-IN")}` : data[k]}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
      <p className="text-sm text-muted-foreground">
        Print any table with Ctrl+P for a PDF export, or download prescription and receipt PDFs from their modules.
      </p>
    </div>
  );
}
